<template>
  <div class="subheader">
    <el-col :offset=3 :span=4 style="text-align: left;">
      <div class="user-name top-info">{{profile.name}}</div>
      <div class="user-address bottom-info">{{profile.address}}</div>
    </el-col>
    <el-col :offset=10 :span=4 style="text-align: right;">
      <div class="current-time top-info">{{time}}{{period}}</div>
      <div class="current-date bottom-info">{{date}}</div>
    </el-col>
  </div>
</template>


<script>
  import { getHourTime, formatTime, getFormattedDate } from '../javascript/helpers'
  import auth from '../auth/index'
  export default {
    name: 'subheader',
    data(){
      return {
        time: '',
        period: '',
        date: '',
        profile:{
          name: '',
          address: ''
        }
      }
    },
    mounted(){
      //To get the time immediately
      this.getTime();
      this.getPeriod();
      this.date = getFormattedDate();
            
      //Sets the timer for the clock
      setInterval(this.updateClock, 1000)
      
      //Sets profile data
      var profile = JSON.parse(auth.getProfile());
      if(profile){
        this.profile.name = profile.client_name;
        this.profile.address = profile.address;
      }
    },
    methods: {
      updateClock(){
        var now = new Date();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        this.period = getHourTime(hours);
        this.time = formatTime(hours, minutes);
      },
      getTime(){
        var now = new Date();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        this.time = formatTime(hours, minutes);
      },
      getPeriod(){
        var now = new Date();
        var hours = now.getHours();
        this.period = getHourTime(hours);
      }
    }
  }
</script>


<style>
  .user-name, .current-time {
    font-weight: 500;
    font-size: 1.3em;
    letter-spacing: 1px;
    color: #656565;
  }

  .user-address, .current-date {
    color: #ABABAB;
  }

  .top-info {
    padding-top: 0.8em;
  }

  .bottom-info {
    padding-bottom: 0.8em;
  }
</style>


// WEBPACK FOOTER //
// SubHeader.vue?43c95116